import { NgModule } from '@angular/core';
import {
  AssetTypeVariantsInputComponent,
  AssetTypeVariantSpecificsDialogComponent
} from './shared/forms/input/variants/variants-input.component';
import { SharedModule } from '../../shared/modules/shared.module';
import { SharedInputModule } from '../../shared/modules/shared-input.module';
import { CommonModule } from '@angular/common';
import { AssetTypeViewReportFieldsComponent } from './shared/view/report-fields/view-report-fields.component';
import { AssetTypeViewVariantsComponent } from './shared/view/variants/view-variants.component';
import { AssetTypeFaultCodesInputComponent, AssetTypeFaultCodesSpecificsDialogComponent } from './shared/forms/input/fault-codes/fault-codes-input.component';
import { AssetTypeViewFaultCodesComponent } from './shared/view/fault-codes/view-fault-codes.component';
import { AssetTypeInspectionChecklistInputComponent } from './shared/forms/input/inspection-checklist/inspection-checklist-input.component';
import { ChecklistsModule } from '../checklists/checklists.module';
import { AssetViewTypeInspectionChecklistComponent } from './shared/view/inspection-checklist/view-inspection-checklist.component';
import { RouterModule } from '@angular/router';
import { AssetTypesImportFromTemplatesButtonComponent, AssetTypesImportFromTemplatesDialogComponent } from './shared/buttons/import-from-templates-button.component';
import { AssetTypesUpdateFromTemplateButtonComponent, AssetTypesUpdateFromTemplateDialogComponent } from './shared/buttons/update-from-template-button.component';
import { AssetTypeReportFieldsComponent } from './shared/forms/input/report-fields/report-fields.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConvertPdfWithAiModule } from '../../shared/components/convert-pdf-with-ai/convert-pdf-with-ai.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SharedInputModule,
    ChecklistsModule,
    RouterModule,
    DragDropModule,
    ConvertPdfWithAiModule
  ],
  declarations: [
    AssetTypeVariantsInputComponent,
    AssetTypeReportFieldsComponent,
    AssetTypeVariantSpecificsDialogComponent,
    AssetTypeViewVariantsComponent,
    AssetTypeFaultCodesInputComponent,
    AssetTypeFaultCodesSpecificsDialogComponent,
    AssetTypeViewFaultCodesComponent,
    AssetTypeInspectionChecklistInputComponent,
    AssetViewTypeInspectionChecklistComponent,
    AssetTypesImportFromTemplatesButtonComponent,
    AssetTypesImportFromTemplatesDialogComponent,
    AssetTypesUpdateFromTemplateButtonComponent,
    AssetTypesUpdateFromTemplateDialogComponent,
    AssetTypeViewReportFieldsComponent,
  ],
  entryComponents: [
    AssetTypeVariantsInputComponent,
    AssetTypeReportFieldsComponent,
    AssetTypeVariantSpecificsDialogComponent,
    AssetTypeViewVariantsComponent,
    AssetTypeFaultCodesInputComponent,
    AssetTypeFaultCodesSpecificsDialogComponent,
    AssetTypeViewFaultCodesComponent,
    AssetTypeInspectionChecklistInputComponent,
    AssetViewTypeInspectionChecklistComponent,
    AssetTypesImportFromTemplatesDialogComponent,
    AssetTypesUpdateFromTemplateDialogComponent,
    AssetTypeViewReportFieldsComponent
  ],
  exports: [
    AssetTypeVariantsInputComponent,
    AssetTypeViewVariantsComponent,
    AssetTypeFaultCodesInputComponent,
    AssetTypeViewFaultCodesComponent,
    AssetTypeInspectionChecklistInputComponent,
    AssetViewTypeInspectionChecklistComponent,
    AssetTypesImportFromTemplatesButtonComponent,
    AssetTypesUpdateFromTemplateButtonComponent,
    AssetTypesUpdateFromTemplateDialogComponent,
    AssetTypeReportFieldsComponent,
    AssetTypeViewReportFieldsComponent
  ],
})
export class AssetTypeSharedModule { }
